import { useEffect } from 'react';

import { ToastContainer } from 'react-toastify';

import { AdminContext } from './admin-context';
import { useWidthState } from './admin-state';

export function Administrator({ children }: { children: React.ReactNode }) {
  const adminState = useWidthState();

  useEffect(() => {
    const preLdr = document.getElementById('ldr');
    if (preLdr) {
      preLdr.classList.add('hidden!');
    }
  }, []);

  return (
    <>
      <ToastContainer
        limit={5}
        position="top-center"
        autoClose={1500}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnHover
        hideProgressBar
        closeButton={false}
        toastClassName="items-start rounded-xl! bg-popover! border border-outline px-5 pt-6 pb-8 text-popover-foreground!"
      />

      <AdminContext value={adminState}>{children}</AdminContext>
    </>
  );
}
